<template>
  <ul :class="brandClasses.list" data-test-id="product-details-bulletin">
    <template v-for="({ label, text, url }, i) in data" :key="i" class="ml-5">
      <li v-if="text || label" class="ml-5">
        <base-link v-if="url" :to="url">
          {{ text || label }}
        </base-link>
        <span v-else>
          <base-interpolator :content="formatBarcodeText(text || label!)">
            <template #product-link="{ args: [pid] }">
              <vf-link
                data-product-barcode-link
                :to="getBarcodeLink()"
              >
                {{ pid }}
              </vf-link>
            </template>
          </base-interpolator>
        </span>
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'

defineProps<{
  data: ProductDetailContent[]
}>()

const { brandClasses } = useAppConfig().components.product.accordions.bulletin

const { productId } = usePdp()
const { formatBarcodeText, getBarcodeLink } = useBarcode(productId.value)
</script>
